export const DEFAULT_LIVE_TUTOR_SUBJECT = 'math';

export function normalizeLiveTutorSubject(subject: string | null | undefined): string {
  const normalized =
    typeof subject === 'string'
      ? subject.trim().toLowerCase().replace(/[\s-]+/g, '_')
      : '';
  if (normalized === 'social_studies' || normalized === 'socialstudy' || normalized === 'socialstudies') {
    return 'history';
  }
  return normalized || DEFAULT_LIVE_TUTOR_SUBJECT;
}
